import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export function StatCard({ label, value, hint, tone = "default", testId }) {
  const toneClass = {
    default: "text-slate-950",
    blue: "text-blue-600",
    green: "text-emerald-600",
    amber: "text-amber-600",
    red: "text-red-600",
    violet: "text-violet-600",
  }[tone];

  return (
    <Card className="border border-slate-200 hover:shadow-md transition-shadow" data-testid={testId}>
      <CardContent className="p-5">
        <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">{label}</div>
        <div className={`num text-3xl font-bold mt-2 ${toneClass}`}>{value}</div>
        {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
      </CardContent>
    </Card>
  );
}

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold text-slate-950 tracking-tight">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Detail({ label, value }) {
  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{label}</div>
      <div className="text-slate-900 mt-1">{value}</div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
    assigned: "bg-blue-100 text-blue-800 border-blue-200",
    in_progress: "bg-orange-100 text-orange-800 border-orange-200",
    visited: "bg-emerald-100 text-emerald-800 border-emerald-200",
    submitted: "bg-green-100 text-green-800 border-green-200",
    completed: "bg-slate-100 text-slate-800 border-slate-200",
  };
  const label = (status || "pending").replace("_", " ");
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-md border ${
        map[status] || map.pending
      }`}
      data-testid="lead-status-badge"
    >
      {label}
    </span>
  );
}
